module.exports = __webpack_public_path__ + "images/emoji/unamused.3e6acc293f4055225495.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/unamused.png
// module id = TZUM
// module chunks = 14